module.exports = __webpack_public_path__ + "img/f280-infiltration.3beb85a1.jpg";